<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close transfer :loading=loading>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [{
					"type": "$inputButton",
					"field": "exchangecode",
					"title": "售后单号",
					"value": null,
					"hidden": false,
					"options": [],
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "ordercode",
					"title": "订单号",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "type",
					"title": "售后类型",
					"value": null,
					"hidden": false,
					"options": [{
							"value": 1,
							"label": "补发"
						},
						{
							"value": 4,
							"label": "仅退款"
						},
						{
							"value": 0,
							"label": "退货"
						},
						{
							"value": 2,
							"label": "换货"
						},
						{
							"value": 5,
							"label": "维修"
						},
						{
							"value": 3,
							"label": "其他"
						}
					],
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "reasonid",
					"title": "问题原因",
					"value": null,
					"hidden": false,
					"props": {
						"name": "exchangeorderreason"
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "reasondetail",
					"title": "问题描述",
					"value": null,
					"hidden": false,
					"props": {
						"inputprops": {
							"type": "textarea"
						},
						"readonly": true
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				// {
				// 	"type": "$upload",
				// 	"field": "upload",
				// 	"title": "upload",
				// 	"value": null,
				// 	"hidden": false,
				// 	"props": {},
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// }
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				modal_model: false,
				modal_title: '录入',
				modal_width: 600,
				modal_height: 500,
				loading: false,
				reasondetail: [],
				exchange: null
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {
			this.$api.exchangeorder.getreasondetail().then((res) => {
				this.reasondetail = res
			})
		},
		mounted() {

		},
		methods: {
			modal_init() {
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()
				})
				this.$emit('show')
			},
			regestevent(rule) {
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}
				})
			},
			reasonidChange(e) {
				if (!e) {
					this.fApi.setValue('reasondetail', null)
					return
				}
				let type = this.fApi.getValue('type')
				let reasondetail = this.reasondetail.find((item) => {
					return item.emunvalueid == e
				})
				if (reasondetail) {
					if (type == 1) {
						this.fApi.setValue('reasondetail', reasondetail.wln_reasondetail_bufa)
					}
					if (type == 4) {
						this.fApi.setValue('reasondetail', reasondetail.wln_reasondetail_jintuikuan)
					}
				}

			},
			exchangecodeButton() {
				let exchangecode = this.fApi.getValue('exchangecode')
				if (!exchangecode) {
					this.$message.error('请输入售后单号')
					return
				}
				this.getexchangeinfo()
			},

			getexchangeinfo() {
				let exchangecode = this.fApi.getValue('exchangecode')
				if (!exchangecode) {
					return
				}
				this.loading = true
				this.$api.exchangeorder.getExchange({
					exchangecode: exchangecode
				}).then((res) => {
					this.loading = false
					this.exchange = res

					let city = []
					if (res.receiver_state) {
						city.push(res.receiver_state)
					}
					if (res.receiver_city) {
						city.push(res.receiver_city)
					}
					if (res.receiver_district) {
						city.push(res.receiver_district)
					}
					city = window.systemMethods.getEmunId('city', city.join('/'))
					this.exchange.city = city

					this.fApi.setValue('ordercode', res.trade_no)
					this.fApi.setValue('type', res.exchange_type)

				}, () => {
					this.loading = false
				})
			},
			setFormData() {
				if (this.sourceData) {
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid() {
				return this.$refs.list
			},
			add() {
				this.getgrid().insert({})
			},
			delete(row) {
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					submitData.param = this.exchange
					this.submitDataFormater(submitData)
					this.loading = true
					this.$api.exchangeorder.enterExchangeorder(submitData).then(() => {
						this.loading = false
						this.$emit('success')
						this.modal_cancel()
					}, () => {
						this.loading = false
					})
					// console.log(submitData)
					// this.getgrid().validate(true, (res) => {
					// 	if (!res) {
					// 		let submitData = JSON.parse(JSON.stringify(formData))
					// 		this.submitDataFormater(submitData)
					// 		let detail = this.getgrid().getTableData().visibleData
					// 		let data = {}
					// 		data.main = submitData
					// 		data.costorder_detail = detail
					// 		this.createJson(data)
					// 		//console.log(data,123123)
					// 		this.$emit('success', {
					// 			data: JSON.stringify(data)
					// 		})
					// 		this.modal_cancel()
					// 		console.log(data)
					// 	} else {
					// for (let i in res) {
					// 	console.log(res[i][0].rule)
					// 	let content = res[i][0].rule.$options.content
					// 	let message = res[i][0].rule.$options.message
					// 	if(content){
					// 		this.$message.error(content)
					// 	}else if(message){
					// 		this.$message.error(message)
					// 	}else{
					// 		this.$message.error('缺少必填项：' + res[i][0].column.title)
					// 	}

					// }
					// 	}
					// })
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k] / 1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i] / 1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>